module.exports = __webpack_public_path__ + "img/GreenOval.e9e72ef9.svg";